import {
    Heading,
    HStack,
    Text,
    VStack,
    Icon,
    Button,
    Tooltip,
    Box,
    StackDivider,
} from '@chakra-ui/react';
import React from 'react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { HiOutlineDatabase } from 'react-icons/hi';
import { ReportingViewBaseConfig } from '../../../base';
import { RecordNewViewProps } from './recordNewProps';
import { RecordFormViewProps } from '../form';

export function createRecordNewView(
    config: ReportingViewBaseConfig & {
        View: {
            Form: React.FC<RecordFormViewProps>;
        };
    }
): React.FC<RecordNewViewProps> {
    const {
        View: { Form: RecordFormView },
    } = config;

    return (props) => {
        const clearButton = props.form.clear;

        return (
            <Box as="form" w="full" {...props.form.form.getFormElementProps()}>
                <VStack
                    w="full"
                    spacing={{ base: 2, md: 4, xl: 6, '2xl': 8 }}
                    align="start"
                    divider={
                        <StackDivider borderWidth={1} borderColor="whiteAlpha.100" />
                    }
                >
                    <VStack w="full" align="start" spacing={4}>
                        <VStack align="start" spacing={0} w="full">
                            <HStack
                                spacing={1}
                                position="relative"
                                left={-3}
                                right={-3}
                                align="center"
                            >
                                <Button
                                    bg="none"
                                    fontWeight="medium"
                                    borderRadius="md"
                                    size="sm"
                                    color="whiteAlpha.600"
                                    _hover={{ bg: 'whiteAlpha.50' }}
                                    leftIcon={
                                        <Icon
                                            as={HiOutlineDatabase}
                                            position="relative"
                                            top={0.5}
                                        />
                                    }
                                    noOfLines={1}
                                    maxW="16rem"
                                >
                                    {props.form.collection.label}
                                </Button>
                                <Icon
                                    as={ChevronRightIcon}
                                    color="whiteAlpha.400"
                                    fontSize="lg"
                                />
                            </HStack>
                            <HStack w="full" justify="space-between">
                                <Heading
                                    fontSize="2xl"
                                    fontWeight="semibold"
                                    color="whiteAlpha.900"
                                    wordBreak="break-word"
                                    userSelect="none"
                                >
                                    {props.title}
                                </Heading>
                                <HStack spacing={2}>
                                    {clearButton && (
                                        <Button
                                            {...clearButton.button}
                                            variant="outline"
                                            size="sm"
                                            border="none"
                                            color="whiteAlpha.600"
                                            bg="none"
                                            _hover={{ bg: 'whiteAlpha.100' }}
                                            _focus={{ outline: 'none' }}
                                        >
                                            {clearButton.label}
                                        </Button>
                                    )}
                                    <Button
                                        {...props.form.save.button}
                                        colorScheme="blue"
                                        size="sm"
                                        _focus={{ outline: 'none' }}
                                    >
                                        {props.form.save.label}
                                    </Button>
                                </HStack>
                            </HStack>
                        </VStack>
                    </VStack>
                    <RecordFormView {...props.form} />
                </VStack>
            </Box>
        );
    };
}
